import {UserModel} from '@core/api/data-access';

export const UserPropsPlacehoderPropType = {
	FullName: 'FullName',
	Email: 'Email',
	PhoneNumber: 'PhoneNumber',
	Title: 'Title',
	Company: 'Company',
	Department: 'Department',
	Notes: 'Notes',
} as const;
export type UserPropsPlacehoderPropType = (typeof UserPropsPlacehoderPropType)[keyof typeof UserPropsPlacehoderPropType];

export enum UserPropsPlaceholderLabel {
	FullName = 'struct.user-edit.fullname',
	Email = 'pages.users.communication.emailSrc',
	PhoneNumber = 'struct.user-edit.phone',
	Title = 'struct.user-edit.title',
	Company = 'struct.user-edit.company',
	Department = 'struct.user-edit.department',
	Notes = 'struct.user-edit.notes',
}

export const UserPropsPlaceHolder = {
	FullName: '{{fullname}}',
	Email: '{{email}}',
	PhoneNumber: '{{phonenumber}}',
	Title: '{{title}}',
	Company: '{{company}}',
	Department: '{{department}}',
	Notes: '{{notes}}',
} as const;
export type UserPropsPlaceHolder = (typeof UserPropsPlaceHolder)[keyof typeof UserPropsPlaceHolder];

export interface ISelectUserPropsPlaceholder {
	label: UserPropsPlaceholderLabel;
	value: UserPropsPlaceHolder;
}

export function isUserPropsPlaceholder(value: string): value is UserPropsPlaceHolder {
	return value && Object.values(UserPropsPlaceHolder).includes(value as UserPropsPlaceHolder);
}

export function replaceUserPropsPlaceholder(value: string, user: UserModel): string {
	const isPlaceHolder = isUserPropsPlaceholder(value);
	if (isPlaceHolder) {
		const userProperty = value.replace('{{', '').replace('}}', '');
		return user[userProperty];
	}
	return value;
}
